import { Card, Modal } from "@carbon6/c6-frontend-design";
import type { ReactNode } from "react";
import { HatModalHeader } from "@/components/modal";
import styles from "./WorkerDetailContent.module.css";

// 세 운영 상세는 같은 크기와 닫기 동작을 사용한다.
export function WorkerDetailFrame({
  open,
  title,
  onClose,
  actions,
  busy = false,
  children,
}: {
  open: boolean;
  title: ReactNode;
  onClose: () => void;
  actions?: ReactNode;
  busy?: boolean;
  children: ReactNode;
}) {
  return (
    <Modal open={open} onClose={onClose} size="lg" style={{ maxWidth: "72rem" }} maxHeight="90vh">
      <HatModalHeader title={title} close={{ disabled: busy }} extraActions={actions} />
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
}

export function WorkerMetric({ label, value }: { label: string; value: ReactNode }) {
  return (
    <Card variant="outlined">
      <Card.Header title={label} />
      <Card.Body>
        <strong className={styles.metric}>{value}</strong>
      </Card.Body>
    </Card>
  );
}
export function WorkerDetailSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className={styles.section}>
      <h3 className={styles.sectionTitle}>{title}</h3>
      <div className={styles.fields}>{children}</div>
    </section>
  );
}
export function WorkerDetailField({
  label,
  children,
  mono = false,
}: {
  label: string;
  children: ReactNode;
  mono?: boolean;
}) {
  return (
    <dl className={styles.field}>
      <dt>{label}</dt>
      <dd className={mono ? styles.mono : undefined}>{children ?? "—"}</dd>
    </dl>
  );
}
